<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="800px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          outlined
          rounded
          text
        >
          Edit
        </v-btn>
        <v-row justify="center">
          <v-dialog v-model="dialogDel" persistent max-width="290">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="red"
                v-bind="attrs"
                v-on="on"
                dark
                outlined
                rounded
                text
                class="my-3"
              >
                Delete
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="headline">
                Delete {{ mod.name }}
              </v-card-title>
              <v-card-text>This Action is permanent!.</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="dialogDel = false">
                  Disagree
                </v-btn>
                <v-btn color="green darken-1" text @click="deleteMod">
                  Agree
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Edit -> {{ mod.name }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  label="Mod Name"
                  :value="mod.name"
                  v-model="mod.name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-checkbox
                  v-model="mod.isShowPrice"
                  label="Is Show Price"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="12">
                <!-- <v-textarea
                  outlined
                  name="input-7-4"
                  label="Description"
                  :value="mod.description"
                  v-model="mod.description"
                ></v-textarea> -->
               <vue-editor v-model="mod.description"></vue-editor>
              </v-col>

              <v-col cols="12" md="12" class="mt-16">
                <div>
                  <h2>Images</h2>
                  <v-btn
                    color="primary"
                    dark
                    outlined
                    rounded
                    text
                    @click="addNewImage"
                  >
                    Add New Image
                  </v-btn>
                </div>

                <div v-for="(img, index) in mod.photos" :key="index">
                  <v-row>
                    <v-col cols="10" md="10">
                      <v-text-field
                        :label="'Image ' + (index + 1)"
                        :value="img.link"
                        v-model="img.link"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2" md="2">
                      <v-btn
                        color="primary"
                        dark
                        outlined
                        rounded
                        text
                        @click="deleteImage(img)"
                      >
                        Delete
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <div>
                  <h2>Youtube</h2>
                </div>
                <v-text-field
                  label="Youtube"
                  :value="mod.videoUrl"
                  v-model="mod.videoUrl"
                  required
                ></v-text-field>
              </v-col>

              <v-col
                v-for="(price, index) in mod.prices"
                :key="index"
                cols="12"
                md="4"
              >
                <div>
                  <h2>{{ price.type }}</h2>
                </div>
                <v-text-field
                  label="Price"
                  :value="price.price"
                  v-model="price.price"
                  required
                ></v-text-field>
                <v-checkbox
                  v-model="price.promotion"
                  label="Promotion Active"
                ></v-checkbox>
                <v-text-field
                  label="Promotion Price"
                  :value="price.pricePromo"
                  v-model="price.pricePromo"
                  required
                ></v-text-field>
                <v-text-field
                  label="Sold"
                  :value="price.sold"
                  v-model="price.sold"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Close
          </v-btn>
          <v-btn color="blue darken-1" text @click="update"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import firebase from "firebase/app";
import "firebase/database";
import { VueEditor } from "vue2-editor";

export default {
  name: "EditModal",
  data: () => ({
    dialog: false,
    dialogDel: false,
  }),
  components: {
    VueEditor
  },
  props: {
    mod: Object,
  },
  methods: {
    addNewImage() {
      this.mod.photos.push({
        link: "",
      });
    },
    deleteImage(img) {
      const index = this.mod.photos.indexOf(img);
      if (index > -1) {
        this.mod.photos.splice(index, 1);
      }
    },
    update() {
      var rev = firebase.firestore().collection("mods").doc(this.mod.idd);
      if (rev) {
        rev.update(this.mod).then(() => {
          console.log(this.mod);
          console.log("Document successfully updated!");
        });
      }
      this.dialog = false;
    },
    deleteMod() {
      firebase
        .firestore()
        .collection("mods")
        .doc(this.mod.idd)
        .delete()
        .then(() => {
          console.log("Document successfully deleted!");
          this.$emit("del-mod", this.mod);
          document.location.reload(true);
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
      this.dialogDel = false;
    },
  },
};
</script>